import { signal } from '@preact/signals-react';
import { Gender, TtsProvider } from '@/api-gen/api.schemas';

export interface PersonaVoiceSettings {
  voiceName: string | null;
  voiceId: string | null;
  sex: Gender;
  ttsProvider: TtsProvider;
  langCode: string;
  speed: number;
}

export const personaVoiceSignal = signal<PersonaVoiceSettings | null>(null);
